
const Data = [
  {
    id: 1,
    category: "education",
    icon: "icon-graduation",
    year: "2026 - present",
    title: "Masters Degree in Information Technology: Machine Learning",
    desc: "Pursuing a Masters degree at University in Bergen (UiB), focusing on machine learning, with courses including algorithms and bioinformatics",
  },
  {
    id: 2,
    category: "education",
    icon: "icon-graduation",
    year: "2023 - 2026",
    title: "Bachelor's Degree in Information Technology",
    desc: "Finished a Bachelor's degree at Western Norway University of Applied Sciences (HVL), focusing on programming, software development, and digital innovation.",
  },
  {
    id: 3,
    category: "education",
    icon:"icon-graduation",
    year: "2017 - 2020",
    title: "High School Diploma",
    desc: "Completed at Danielsen High School with a focus on science and technology, laying the foundation for further studies in IT.",
  },
  {
    id: 4,
    category: "experience",
    icon: "icon-briefcase",
    year: "AUG 2024 - DEC 2025",
    title: "Student Teaching Assistant | HVL",
    desc: "Assisted as a Student Teacher Assistant in 3 courses: DAT100 - Foundational Programming, DAT102 - Algorithms and Data Structures & DAT103 - Computers and Operating Systems.",
  },
  {
    id: 5,
    category: "experience",
    icon: "icon-briefcase",
    year: "JUN 2025 - AUG 2025",
    title: "Summer Intern | DNB",
    desc: "Worked on a software development project with 3 other summer interns, contributing to the design, implementation and testing of the functionality. Gained experience in SwiftUI on frontend and AWS integration, while further developing my Java backend knowledge.",
  },
  {
    id: 6,
    category: "experience",
    icon: "icon-briefcase",
    year: "AUG 2023 - MAY 2025",
    title: "Student Assistant | Learning Lab, HVL",
    desc: "Assisting students and faculty with advanced technology, including 3D printers, VR headsets, and multimedia equipment, while providing training and technical support.",
  },
  {
    id: 7,
    category: "experience",
    icon: "icon-briefcase",
    year: "JUN 2024 - AUG 2024",
    title: "Summer Intern | Omega 365",
    desc: "Worked on software development projects, contributing to the design, testing, and implementation of applications. Gained experience in project management and agile methodologies.",
  },
  {
    id: 8,
    category: "experience",
    icon: "icon-briefcase",
    year: "JAN 2022 - AUG 2023",
    title: "Kindergarten Substitute | Espira Grønnestølen Barnehage",
    desc: "Supervised children aged 7 months to 6 years, managed activities, and provided care for children with special needs. Developed skills in child development and conflict resolution.",
  },
  {
    id: 9,
    category: "volunteer",
    icon: "icon-heart",
    year: "2018 - present",
    title: "Volunteer | Childhood Cancer Association",
    desc: "Coordinated events and served as travel leader for children with cancer. Provided emotional support as a peer support coordinator at grief retreats for families who lost a child to cancer.",
  },
  {
    id: 10,
    category: "volunteer",
    icon: "icon-heart",
    year: "2023 - 2024",
    title: "Event Coordinator | ROOT Student Association",
    desc: "Led the planning and execution of social events for IT students, ensuring effective coordination and collaboration with vendors and student groups.",
  },
];

export default Data;
